import { Http } from '@/utils/request';
import {
  addTestAccountParams,
  addTestAccountParamsItem,
  OpenAppBffV1AppTestAccountListReplyTestAccount,
} from './type/addTestAccount';

export const fetchTestAccounts = async (params: addTestAccountParams) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/testaccounts`
  ).json<APIRes<OpenAppBffV1AppTestAccountListReplyTestAccount[]>>();
};

export const postTestAccounts = async (params: addTestAccountParams) => {
  return await Http.post(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/testaccounts`,
    {
      json: params,
    }
  ).json<APIRes<never>>();
};

export const deleteTestAccounts = async (params: addTestAccountParams) => {
  return await Http.delete(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/testaccounts/${params.accountId}`
  ).json<APIRes<never>>();
};

export const getEmails = async (params: addTestAccountParamsItem) => {
  return await Http.get(
    `open-app-bff/users/me/teams/${params.teamId}/apps/${params.appId}/testaccounts/${params.id}`
  ).json<APIRes<OpenAppBffV1AppTestAccountListReplyTestAccount>>();
};
